import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data } from './types'

export const GET_ASTERIO_BID_TOKEN: TypedDocumentNode<Data> = gql`
  query getAsterioBidToken {
    prebidManagerPublisherToken
  }
`
